import { createSelector } from "@ngrx/store";
import { AppStateInterface } from "../../appState.interface";

export const selectFeature = (state: AppStateInterface) => state.devices;

export const isLoadingSelector = createSelector(
    selectFeature, 
    (state) => state.isLoading
);

export const isLoadingImportSelector = createSelector(
    selectFeature, 
    (state) => state.isLoadingImport
);

export const devicesSelector = createSelector(
    selectFeature, 
    (state) => state.devices
);

export const activeDeviceSelector = createSelector(
    selectFeature,
    (state) => state.activeDevice
)

export const errorSelector = createSelector(
    selectFeature, 
    (state) => state.error
);